var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('Kopf',{attrs:{"assetName":"rss","title":"Chats"}}),_vm._l((_vm.chats),function(chat){return _c('div',{key:chat.cid},[_c('ChatListElement',{attrs:{"chat":chat}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }